<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ props: { disabled: disableSubmit } }"
    @cancel="handleCancel"
    cancelText="关闭">
    <efs-md-contract-price-change-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></efs-md-contract-price-change-form>
  </j-modal>
</template>

<script>

  import EfsMdContractPriceChangeForm from './EfsMdContractPriceChangeForm'
  export default {
    name: 'EfsMdContractPriceChangeModal',
    components: {
      EfsMdContractPriceChangeForm
    },
    data () {
      return {
        title:'',
        width:1425,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>